import styled from 'styled-components';
import { SYS_BREAKPOINT_XS, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT, SYS_SPACE_FIXED_150, } from '@oneaudi/unified-web-common';
export const FinanceContainer = styled.div `
  margin-bottom: ${(props) => (props.isPLP ? SYS_SPACE_FIXED_350 : '')};
`;
export const PriceInformationContainer = styled.div ``;
export const RateWrapper = styled.div `
  display: flex;
  flex-grow: 1;
  margin: 0;
  align-items: center;
`;
export const PriceAndInfoIWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
`;
export const RateNextToInfoI = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
export const PriceRow = styled.div `
  display: flex;
  flex-direction: row;
  > h4 {
    color: ${SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT};
  }
`;
export const AlertModal = styled.div `
  text-align: center;
  display: flex;
  flex-direction: column;
  min-height: 150px;
  justify-content: space-between;
`;
export const PriceWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
  align-items: flex-start;
  //background-color: #bada55;
  margin-bottom: ${SYS_SPACE_FIXED_350};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    align-items: flex-end;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    flex-direction: row;
    align-items: flex-end;
  }
`;
export const SecondaryPriceWrapper = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_150};
`;
export const RegularAndRetailPrice = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_300};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: 0;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-bottom: ${SYS_SPACE_FIXED_300};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin-bottom: 0;
  }
`;
export const PriceContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const MonthlyRateContainer = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    border-left: 2px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT};
    padding-left: ${SYS_SPACE_FIXED_300};
    margin-left: ${SYS_SPACE_FIXED_300};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    border-left: 0;
    padding-left: 0;
    margin-left: 0;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    border-left: 2px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT};
    padding-left: ${SYS_SPACE_FIXED_300};
    margin-left: ${SYS_SPACE_FIXED_300};
  }
`;
export const DisclaimerWrapper = styled.div `
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    max-width: ${SYS_BREAKPOINT_XS};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    max-width: ${SYS_BREAKPOINT_SM};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    max-width: ${SYS_BREAKPOINT_SM};
  }
`;
export const DisclaimerContainer = styled.div `
  padding: ${SYS_SPACE_FIXED_150} 0px 0px 0px;
`;
export const ChangeRateLink = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-top: 30px;
`;
